import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {
    PortfolioBalanceProfile
} from "../../portfolio-profile/components/charts/portfolio-balance-profile/PortfolioBalanceProfile";

export function MaximizedPortfolioBalanceChartDialog({
    isOpen,
    setIsOpen,
}: {
    isOpen: boolean,
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
}) {
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsOpen(false);
    };
    
    return (
        <>
            <Dialog
                fullScreen
                open={isOpen}
                PaperProps={{
                    component: 'form',
                    onSubmit: handleSubmit,
                }}
            >
                <DialogContent>
                    <PortfolioBalanceProfile fullSize={true} />
                </DialogContent>
            </Dialog>
        </>
    );
}